export var CLIENT_VERSION = "4.18.0";